import { render } from "./BeamTableCellCheckbox.vue?vue&type=template&id=8922b736&scoped=true"
import script from "./BeamTableCellCheckbox.vue?vue&type=script&lang=js"
export * from "./BeamTableCellCheckbox.vue?vue&type=script&lang=js"

import "./BeamTableCellCheckbox.vue?vue&type=style&index=0&id=8922b736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8922b736"]])

export default __exports__